export default __webpack_public_path__ + "static/media/licenses.a4f11b79.jpg";